import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class LeaveAttendanceRecords extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
      downloads_div:'',
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','employee_leave_and_attendance_records');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
            cutThis.downloads_files(data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  downloads_files(data){
    var emp_id  = data['emp_id'];
    var file_id = data['id'];
    var downloads_div = [];
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'attendance_update')}><i class="fas fa-file-download"></i> Bank Account Passbook</a></div>);
    this.setState({downloads_div});
  }

  check_download_file(file_id,emp_id,file_name){
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var form_type         = 'employee_leave_and_attendance_records';
    var url = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_download_employee_files_url.php";
    }else{
      url = "/php/admin_download_employee_files_url.php";
    }
    var new_str = '?emp_id='+emp_id+"&file_id="+file_id+'&file_name='+file_name+"&function=check_download_emp_file&form_type="+form_type+"&web_token="+web_token;
    window.open(url+new_str, '_blank');
  }

  update_info(data){
    $('#total_aeaves_available').val(data['total_aeaves_available']);
    $('#leave_balance').val(data['leave_balance']);
    $('#attendance_tracking').val(data['attendance_tracking']);
    $('#shift_timings').val(data['shift_timings']);

    $('#old_attendance_update').val(data['attendance_update_new_name']);
  }

  add_emp_basic_details(){
    var file_main_ext       = ['pdf','PDF'];
    var cutThis             = this;
    var emp_id              = cutThis.props.id;
    var web_token           = window.isNullAndUndef($('#web_token').val());

    var total_aeaves_available    = window.isNullAndUndef($('#total_aeaves_available').val());
    var leave_balance          = window.isNullAndUndef($('#leave_balance').val());
    var attendance_tracking           = window.isNullAndUndef($('#attendance_tracking').val());
    var shift_timings              = window.isNullAndUndef($('#shift_timings').val());

    var attendance_update_temp    = window.isNullAndUndef($('#attendance_update').val());
    var org_attendance_update     = $("#attendance_update").prop("files")[0];
    var attendance_update_name    = $('#attendance_update').val().split('\\').pop();



    var attendance_update_ext    = '';

    if(attendance_update_temp){
      attendance_update_ext       = attendance_update_temp.split('.').pop();
    }

    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(total_aeaves_available && leave_balance && attendance_tracking && shift_timings && file_main_ext.indexOf(attendance_update_ext) >= 0){
      var old_attendance_update                 = $('#old_attendance_update').val();
      var all_data                              = {};
      all_data['total_aeaves_available']        = window.return_false_null(total_aeaves_available);
      all_data['leave_balance']              = window.return_false_null(leave_balance);
      all_data['attendance_tracking']               = window.return_false_null(attendance_tracking);
      all_data['shift_timings']                  = window.return_false_null(shift_timings);

      all_data['attendance_update']             = window.return_false_null(attendance_update_name);
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('attendance_update',org_attendance_update);
      body.append('old_attendance_update',old_attendance_update);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','employee_leave_and_attendance_records');
      body.append('function','add_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
          cutThis.get_emp_basic_details();
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('total_aeaves_available','leave_balance','attendance_tracking','shift_timings','attendance_update');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }

  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="total_aeaves_available" placeholder="Total Leaves available"/>
                                        <label for="name">Total Leaves available</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="leave_balance" placeholder="Leave Balance"/>
                                        <label for="name">Leave Balance</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="attendance_tracking" placeholder="Attendance Tracking"/>
                                        <label for="name">Attendance Tracking</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="shift_timings" placeholder="Shift Timings &amp; Work Schedule"/>
                                        <label for="name">Shift Timings &amp; Work Schedule</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_attendance_update" placeholder=""/>
                                        <input type="file" className="form-control" id="attendance_update" placeholder="Attendance update"/>
                                        <label for="name">Attendance update</label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="col-md-4">
                                      <p id="error_msg"></p>
                                    </div>
                                    <div className="col-md-4">
                                      <p># Form upload, only allow PDF</p>
                                    </div>
                                    <div className="col-md-4 p-0 float_r">
                                        {this.state.submit_button}
                                    </div>
                                </div>
                                {this.state.downloads_div}

                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default LeaveAttendanceRecords;
